import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { type ReactNode, useId } from "react";

type UnpostDialogProps = {
  open: boolean;
  title: string;
  description: string;
  details?: ReactNode;
  confirmTestId: string;
  onClose: () => void;
  onConfirm: () => void;
};

export default function UnpostDialog({
  open,
  title,
  description,
  details,
  confirmTestId,
  onClose,
  onConfirm,
}: UnpostDialogProps) {
  const titleId = useId();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={titleId}
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          padding: "24px 36px",
          margin: "auto",
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle id={titleId} sx={{ marginBottom: 2, p: 0 }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <Typography
          paragraph
          sx={{
            fontSize: "0.875rem",
            fontWeight: 400,
            color: "#475467",
            marginBottom: 0,
          }}
        >
          {description}
        </Typography>
        {details}
      </DialogContent>
      <DialogActions>
        <Button sx={{ borderRadius: "8px" }} variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button
          sx={{ borderRadius: "8px" }}
          color="error"
          variant="contained"
          onClick={onConfirm}
          data-testid={confirmTestId}
        >
          I checked the PMS, unpost
        </Button>
      </DialogActions>
    </Dialog>
  );
}
